import { render, staticRenderFns } from "./redirect_shopify_v2.vue?vue&type=template&id=64b70728"
import script from "./redirect_shopify_v2.vue?vue&type=script&lang=js"
export * from "./redirect_shopify_v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports